module.exports = __webpack_public_path__ + "static/img/cma-top-logo.97731bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cma-top-logo.png
// module id = 3tOb
// module chunks = 12